export default __webpack_public_path__ + "static/sheetbezel-d3a368fc6d34fbcef7fdc2ad0df2d587.png";